import React from 'react';
import style from './index.scss';

const HeaderPanel = ({ title, data }) => {
  const panelBodyFields = data.map((dataItem, dataItemIndex) => {
    if (dataItem) {
      return (
        <div key={dataItemIndex} className={style.panelFieldSet}>
          <div className="row">
            <div className="col-sm-6">
              <span className={style.fieldLabel}>
                {dataItem.fieldLabel || '--'}
              </span>
            </div>
            <div className="col-sm-6">
              <span className={style.fieldValue}>
                {dataItem.fieldValue || '--'}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  });

  return (
    <div className={style.panelContainer}>
      <div className={style.panelHeader}>
        <p className={style.headerTitle}>{title || ''}</p>
      </div>
      <div className={style.panelBody}>{panelBodyFields}</div>
    </div>
  );
};

export default HeaderPanel;
